import React, { Component } from "react";
import _ from "lodash";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Image,
  ActivityIndicator,
} from "react-native";
import { WebView } from "react-native-webview";
import staticColors from "../constants/staticColors";
import { getPrixaEngine, getParameterByName } from "../helpers/storage";

const injectJs =
  "const element = document.getElementsByClassName('prixa-menubar');" +
  "if(element.length > 0) { element[0].style.display = 'none'; }";

class MedicalCheck extends Component {
  state = {
    loading: true,
    url: "",
  };

  onNavigationStateChange = (state) => {
    if (state.loading) {
      this.setState({
        loading: true,
      });
    } else {
      this.setState({
        loading: false,
      });
    }

    const url = state.url;
    if (String(url).indexOf("/consultation-start") >= 0) {
      const sessionId = getParameterByName("sessionID", url);
      this.getConsultationDetails(sessionId);
    }
  };

  getConsultationDetails = async (sessionId) => {
    const prixaEngine = getPrixaEngine();
    const rp = fetch(prixaEngine.prixaEngineBaseUrl + "prixa", {
      method: "POST",
      headers: {
        "x-prixa-api-key": prixaEngine.apiKey,
        "x-partner-app-id": prixaEngine.partnerAppId,
        "x-partner-id": prixaEngine.partnerId,
      },
      body: JSON.stringify({
        sessionId,
        reply: {
          type: "resume",
        },
      }),
    });
    const response = await rp;
    const json = await response.json();

    const consultation = [];
    const profiles = _.get(json.result, "actions.diagnosisResult.profiles", []);
    const symptoms = _.get(json.result, "actions.diagnosisResult.symptoms", []);
    const diseases = _.get(json.result, "actions.diagnosisResult.diseases", []);

    // STATUS KESEHATAN DAN KEBIASAAN
    consultation.push("STATUS KESEHATAN DAN KEBIASAAN");
    let histories = [];
    if (profiles.length > 0) {
      histories = _.filter(profiles, (profile) => profile.type === "history");
    }
    const historyText = [];
    _.forEach(histories, (history) => {
      historyText.push(`- ${history.nameIndo}`);
    });
    consultation.push(historyText.length > 0 ? historyText.join("\n") : "-");
    consultation.push(""); // new line

    // BMI
    consultation.push("BMI");
    const weight = _.get(
      json.result,
      "actions.diagnosisResult.user.weight",
      "-"
    );
    const height = _.get(
      json.result,
      "actions.diagnosisResult.user.height",
      "-"
    );
    const bmiProfile = _.find(profiles, (profile) => profile.type === "bmi");
    const bmiStatus = bmiProfile ? bmiProfile.nameIndo : "-";
    consultation.push(
      `Tinggi: ${height} cm | berat badan ${weight} kg (${bmiStatus})`
    );
    consultation.push(""); // new line

    // KELUHAN UTAMA
    let mainSymptoms = [];
    if (symptoms.length > 0) {
      mainSymptoms = _.filter(
        symptoms,
        (symptom) => symptom.answer === "yes" && symptom.chief
      );
    }
    consultation.push("KELUHAN UTAMA");
    const mainSymptomsText = [];
    _.forEach(mainSymptoms, (symptom) => {
      mainSymptomsText.push(symptom.symptomName);
    });
    consultation.push(
      mainSymptomsText.length > 0 ? mainSymptomsText.join(", ") : "-"
    );
    consultation.push(""); // new line

    // KELUHAN LAIN
    let otherSymptoms = [];
    if (symptoms.length > 0) {
      otherSymptoms = _.filter(
        symptoms,
        (symptom) => symptom.answer === "yes" && !symptom.chief
      );
    }
    consultation.push("KELUHAN LAIN");
    const otherSymptomsText = [];
    _.forEach(otherSymptoms, (symptom) => {
      otherSymptomsText.push(`- ${symptom.symptomName}`);
    });
    consultation.push(
      otherSymptomsText.length > 0 ? otherSymptomsText.join("\n") : "-"
    );
    consultation.push(""); // new line

    // TIDAK ADA KELUHAN
    consultation.push("TIDAK ADA");
    let noSymptoms = [];
    if (symptoms.length > 0) {
      noSymptoms = _.filter(symptoms, (symptom) => symptom.answer === "no");
    }
    const noymptomsText = [];
    _.forEach(noSymptoms, (symptom) => {
      noymptomsText.push(`- ${symptom.symptomName}`);
    });
    consultation.push(
      noymptomsText.length > 0 ? noymptomsText.join("\n") : "-"
    );
    consultation.push(""); // new line

    // TIDAK TAHU
    let unknownSymptoms = [];
    if (symptoms.length > 0) {
      unknownSymptoms = _.filter(
        symptoms,
        (symptom) => symptom.answer === "unknown"
      );
    }
    consultation.push("TIDAK TAHU");
    const unknownSymptomsText = [];
    _.forEach(unknownSymptoms, (symptom) => {
      unknownSymptomsText.push(`- ${symptom.symptomName}`);
    });
    consultation.push(
      unknownSymptomsText.length > 0 ? unknownSymptomsText.join("\n") : "-"
    );

    const consultationText = consultation.join("\n");

    const { navigation } = this.props;
    const param = {
      patientId: navigation.state.params.patientId,
      dependent: _.get(navigation.state.params, "dependent", null),
      consultation: consultationText,
      complaintIds: [],
      duration: 1,
      durationUnit: "day",
    };
    this.props.navigation.replace("Consent", param);
  };

  componentDidMount() {
    const { url } = this.props.navigation.state.params;
    this.setState({
      url,
    });
  }

  render() {
    const { loading, url } = this.state;
    return (
      <View style={{ flex: 1 }}>
        <View style={styles.closeContainer}>
          <TouchableOpacity onPress={() => this.props.navigation.goBack()}>
            <Image
              source={require("../assets/close.png")}
              width={25}
              style={styles.icon}
            />
          </TouchableOpacity>
        </View>
        {url ? (
          <React.Fragment>
            <WebView
              onNavigationStateChange={this.onNavigationStateChange}
              source={{ uri: url }}
              style={{ flex: 1 }}
              originWhitelist={["https://*"]}
              injectedJavaScript={injectJs}
            />
            {loading ? (
              <View style={styles.activityIndicator}>
                <ActivityIndicator
                  style={{ flex: 1 }}
                  size="large"
                  color="#FFF"
                />
              </View>
            ) : null}
          </React.Fragment>
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  closeContainer: {
    padding: 16,
    backgroundColor: staticColors.grey,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  icon: {
    width: 25,
    height: 25,
  },
  activityIndicator: {
    flex: 1,
    position: "absolute",
    width: "100%",
    height: "100%",
    marginTop: 40,
    backgroundColor: staticColors.grey,
  },
});

export default MedicalCheck;
